const TOP_BILLED_CAST = [
  {
    name: 'Amber Midthunder',
    shortName: 'Naru',
    img: 'https://www.themoviedb.org/t/p/w138_and_h175_face/f8VWGyaIS38NkDIzQ2hapXKt0N5.jpg',
  },
  {
    name: 'Dane DiLiegro',
    shortName: 'Predator',
    img: 'https://www.themoviedb.org/t/p/w138_and_h175_face/aUemYqMIbk17qDqNHkGc48WUJv8.jpg',
  },
  {
    name: 'Stormee Kipp',
    shortName: 'Wasape',
    img: 'https://www.themoviedb.org/t/p/w138_and_h175_face/zMAvWK5V3El3nJvrJbqPVBFSm5P.jpg',
  },
  {
    name: 'Michelle Thrush',
    shortName: 'Aruka',
    img: 'https://www.themoviedb.org/t/p/w138_and_h175_face/oU1Y8q2uX1JPZTOkpPgxs3MOUN9.jpg',
  },
  {
    name: 'Julian Black Antelope',
    shortName: 'Chief Kehetu',
    img: 'https://www.themoviedb.org/t/p/w138_and_h175_face/tULt7BBKT7lRQNBbTz7z8zyZAwQ.jpg',
  },
  {
    name: 'Stefany Mathias',
    shortName: 'Sumu (Chief Wife)',
    img: 'https://www.themoviedb.org/t/p/w138_and_h175_face/ziJ5fXAQVJ6X5y6vLpcmze1dyp.jpg',
  },
  {
    name: 'Nelson Leis',
    shortName: 'Waxed Mustache',
    img: 'https://www.themoviedb.org/t/p/w138_and_h175_face/olMl35MmkOmOp17CC3519wG30D7.jpg',
  },
  {
    name: 'Bennett Taylor',
    shortName: 'Raphael',
    img: 'https://www.themoviedb.org/t/p/w138_and_h175_face/eYOy0t1Obo7X9J6KsAUmgOfp56o.jpg',
  },
  {
    name: 'Mike Paterson',
    shortName: 'Big Beard',
    img: 'https://www.themoviedb.org/t/p/w138_and_h175_face/wFTojLov6QWbLNEWIgUVVVloyvz.jpg',
  },
];

const REVIEWS = [
  {
    name: 'Per Gunnar Jonsson',
    img: 'https://www.gravatar.com/avatar/cbabaea0fa98692d00130498d7ac5d7c.jpg?s=64',
    rating: 5,
    date: 'August 14, 2022',
    content: `I guess I have to start by saying that this movie was a lot better than some of the latest entries in the Predator franchise but then, that is not really difficult so it does not say that much. Personally, I think this movie is rather 
    
Cinematically it is not a bad movie. I liked the footage for the most part. Story wise, well, for the first half of the movie I found it rather boring actually.

There was some brief scenes with a wolf and later a bear that had some action in it but for the most part the main protagonist ran around moping and whining and trying to pretend to be worthy of being a great warrior. Somewhat unrealistic of course since Hollywood, of course, had cast a woman in the role. Not that I have anything against it per see but at the time this movie is supposed to happen a women, native Indian or not, stayed at home doing the chores whether Hollywood tries to pretend otherwise or not.
As I said, I m still okay with that but she spends most of the time fumbling, stumbling and when a threat comes around she runs and looks scared. Not the kind of great warrior charisma that I was hoping for in the main protagonist.
When it finally starts to get interesting she stumbles into a bloody animal trap and gets caught by a hunting party. The latter which of course is portrayed as the typical Hollywood stereotype of “white man bad”. Minor details like, having your foot caught in that kind of steel trap would render you useless for the rest of the movie, is of course ignored.
The later half of the movie has some action in it at least which is dragged down by the main protagonists moping and the fact that, when she finally has the chance of taking a shot, she just stares stupidly for half a minute and voila, the chance is gone.
On the good side is that the actors are doing a pretty decent job of the not so great script they were given and, as I mentioned, cinematically it is a quite good movie. The action, when it happens, is pretty good if one ignores the Hollywood stupidities and the not so kick-behind main protagonist.
Overall the movie is watchable and, as I wrote, better than previous instalments in the franchise but that is about it.`,
  },
];
const DISCUSSIONS = [
  {
    name: 'cpheonix',
    content: 'Really well done',
    time: 'Aug 17, 2022 at 3:41 AM',
    avatar:
      'https://www.themoviedb.org/t/p/w45_and_h45_face/2cOl4h8baLF7DuANoSIzZyhHKrQ.jpg',
    status: 'Open',
    rating: '10',
  },
  {
    name: 'Grownvie',
    content: 'Me senti em 1987',
    time: 'Aug 09, 2022 at 9:18 AM',
    avatar:
      'https://www.themoviedb.org/t/p/w45_and_h45_face/ildxsvkjfVL523xIXvHum4Hl6uK.png',
    status: 'Open',
    rating: '3',
  },
  {
    name: 'Ask Me Anything',
    content: 'Trailer: Pocahontas takes on the Predator',
    time: 'Aug 07, 2022 at 10:46 AM',
    avatar:
      'https://www.themoviedb.org/t/p/w45_and_h45_face/2cOl4h8baLF7DuANoSIzZyhHKrQ.jpg',
    status: 'Open',
    rating: '6',
  },
];

const KEYWORDS = [
  'hunter',
  'alien life-form',
  'prequel',
  'alien',
  'native american',
  'bear',
  'decapitation',
  'severed head',
  'dog',
  'severed foot',
  'bear attack',
  'comanche',
  'indigenous peoples',
  'severed arm',
  'dog hero',
  '1700s',
];

const MEDIAS = [
  {
    title: 'Most Popular',
  },
  {
    title: 'Videos',
  },
  {
    title: 'Backdrops',
  },

  {
    title: 'Poster',
  },
];

const CONTRIBUTOR = [
  {
    score: 229,
    name: 'raze646',
    avatar:
      'https://www.themoviedb.org/t/p/w45_and_h45_face/yYG7Rhn9HfFpssIMeNiDynvxC14.jpg',
  },
  {
    score: 63,
    name: 'Fougasse',
    avatar:
      'https://www.themoviedb.org/t/p/w45_and_h45_face/qZW7TazXYrGysGBgO6ygeAaC4WO.jpg',
  },
  {
    score: 63,
    name: 'heli5m',
    avatar:
      'https://www.gravatar.com/avatar/3af6511cf44a709e6ae5b612903c846c.jpg?s=45',
  },
  {
    score: 16,
    name: 'PeGAS12',
    avatar:
      'https://www.themoviedb.org/t/p/w45_and_h45_face/ildxsvkjfVL523xIXvHum4Hl6uK.png',
  },
];

const RECOMMENTS = [
  {
    title: 'The Princess',
    rating: 7,
    date: '06/16/2022',
    backdrops:
      'https://www.themoviedb.org/t/p/w250_and_h141_face/5PnypKiSj2efSPqThNjTXz8jwOg.jpg',
  },
  {
    title: 'Not Okey',
    rating: 6.6,
    date: '06/16/2022',
    backdrops:
      'https://www.themoviedb.org/t/p/w250_and_h141_face/bHTAaLCXnMTThs57mAbptjmOLX2.jpg',
  },
  {
    title: 'Last Moment of Clarity',
    rating: 5.3,
    date: '06/16/2022',
    backdrops:
      'https://www.themoviedb.org/t/p/w250_and_h141_face/fqkOjx7XrBU6Hi0ZcgINwtmaXns.jpg',
  },
  {
    title: 'The Gray Man',
    rating: 7.1,
    date: '06/16/2022',
    backdrops:
      'https://www.themoviedb.org/t/p/w250_and_h141_face/27Mj3rFYP3xqFy7lnz17vEd8Ms.jpg',
  },
  {
    title: 'The Man from Toronto',
    rating: 6.5,
    date: '06/16/2022',
    backdrops:
      'https://www.themoviedb.org/t/p/w250_and_h141_face/iOFBH9KtjKMntbP2kheeOpMQTcC.jpg',
  },
  {
    title: 'Predator 2',
    rating: 6.2,
    date: '06/16/2022',
    backdrops:
      'https://www.themoviedb.org/t/p/w250_and_h141_face/7PoWlbQg7ZxgwofFRrkytvpLvJD.jpg',
  },
  {
    title: 'Nope',
    rating: 7,
    date: '06/16/2022',
    backdrops:
      'https://www.themoviedb.org/t/p/w250_and_h141_face/xVbppM1xgbskOKgOuV8fbWBWHtt.jpg',
  },
  {
    title: 'Predator',
    rating: 7.5,
    date: '06/16/2022',
    backdrops:
      'https://www.themoviedb.org/t/p/w250_and_h141_face/qpS5pfZJcirPTDpvckpczKJIsO0.jpg',
  },
];

const MENU = [
  {
    title: 'Overview',
    children: [
      {
        title: 'Main',
      },
      {
        title: 'Alternative Titles',
      },
      {
        title: 'Cast & Crew',
      },
      {
        title: 'Release Dates',
      },
      {
        title: 'Translations',
      },
      {
        title: 'Changes',
      },
      {
        title: 'Report',
      },
    ],
  },
  {
    title: 'Media',
    children: [
      {
        title: 'Backdrops',
        count: 18,
      },
      {
        title: 'Logo',
        count: 19,
      },
      {
        title: 'Poster',
        count: 98,
      },
      {
        title: 'Videos',
        children: [
          {
            title: 'Trailers',
            count: 3,
          },
          {
            title: 'Teasers',
          },
          {
            title: 'Clips',
          },
          {
            title: 'Behind the Scences',
          },
          {
            title: 'Featurettes',
            children: [
              {
                title: 'Trailers',
                count: 3,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    title: 'Disscussion',
    children: [
      {
        title: 'Overview',
      },
      {
        title: 'General',
        count: 4,
      },
      {
        title: 'Content Issues',
        count: 3,
      },
    ],
  },
  {
    title: 'Share',
    children: [
      {
        title: 'Share link',
      },
      {
        title: 'Facebook',
      },
      {
        title: 'Tweet',
      },
    ],
  },
];

export {
  TOP_BILLED_CAST,
  REVIEWS,
  DISCUSSIONS,
  KEYWORDS,
  MEDIAS,
  CONTRIBUTOR,
  RECOMMENTS,
  MENU,
};
